module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    attrs: {
      "id": "invites-page"
    }
  }, [(_vm.isLoading) ? _c('loader-large') : _vm._e(), _vm._v(" "), (_vm.noPendingInvitations) ? _c('section', {
    staticClass: "validation-messages friendly"
  }, [_vm._v("\n        You have no pending Invitations\n    ")]) : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.invitationsToGames.length > 0) ? _c('section', {
    staticClass: "invite-list"
  }, [_c('h2', [_vm._v("Invitations to Game Projects")]), _vm._v(" "), _vm._l((_vm.invitationsToGames), function(invitation) {
    return _c('invitation-to-game', {
      attrs: {
        "invitation": invitation
      }
    })
  })], 2) : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.requestsToJoin.length > 0) ? _c('section', {
    staticClass: "invite-list"
  }, [_c('h2', [_vm._v("Requests to Join your Game Projects")]), _vm._v(" "), _vm._l((_vm.requestsToJoin), function(request) {
    return _c('request-to-join', {
      attrs: {
        "request": request
      }
    })
  })], 2) : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.sentInvitationsToGames.length > 0) ? _c('section', {
    staticClass: "invite-list"
  }, [_c('h2', [_vm._v("Sent Invitations to Game Projects")]), _vm._v(" "), _vm._l((_vm.sentInvitationsToGames), function(invitation) {
    return _c('sent-invitation-to-game', {
      attrs: {
        "invitation": invitation
      }
    })
  })], 2) : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.sentRequestsToJoin.length > 0) ? _c('section', {
    staticClass: "invite-list"
  }, [_c('h2', [_vm._v("Sent Requests to Join Game Projects")]), _vm._v(" "), _vm._l((_vm.sentRequestsToJoin), function(request) {
    return _c('sent-request-join', {
      attrs: {
        "request": request
      }
    })
  })], 2) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d8b28c4c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Pages/InvitationRequests/InvitesPage.vue
// module id = 919
// module chunks = 2